import { Box, Grid, Tab } from "@mui/material";
import "./FundingEvaluation.scss";
import React from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import "../../assets/css/payment.scss";
import PricingBox from "../../components/ReusableComponents/PricingBox";
import AccountBalanceList from "../../components/Payment/AccountBallanceList";
import HeadAndDesc from "../../components/ReusableComponents/HeadAndDesc";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { dollarUS } from "./../../utilities/formatters";
import logoutReducer from "../../store/reducers/logout";
import { axiosInstance } from "../../Axios";
import { tokenConfig } from "../../store/reducers/tokenReducer";
import { myStore } from "../..";
import Challenges from "../../components/NewDashboard/Challenges";
import Loader from "../../reusableComponents/Loader";
import { setLoading } from "../../store/reducers/loader";
import MobileTabs from "../../reusableComponents/MobileTabs/MobileTabs";

const isFreeTrial = (s) => String(s).toLowerCase().includes("free");

const FreeTrial = ({ Data, index }) => {
  const navigate = useNavigate();
  const handleNavi = (id) => {
    navigate(`/FundingEvaluationPayment/${id}`);
  };
  return (
    <Grid
      container
      item
      className="PricingContainer"
      xs={12}
      sm={4}
      md={3}
      lg={3}
    >
      <div className="PricingBox">
        <div className="PricingHead mbb-20"> {Data && Data.name} </div>
        <PricingBox PricingList={Data && Data.Leverage} />
        <PricingBox
          PricingList={dollarUS(Data && Data.Evaluation_Phase_1)}
          percentage={
            (Data.Evaluation_Phase_1 / Data.account_balance) * 100 + "%"
          }
        />
        <PricingBox
          PricingList={dollarUS(Data && Data.Evaluation_Phase_2)}
          percentage={
            (Data.Evaluation_Phase_2 / Data.account_balance) * 100 + "%"
          }
        />
        <PricingBox
          PricingList={dollarUS(Data && Data.Max_Loss)}
          percentage={(Data.Max_Loss / Data.account_balance) * 100 + "%"}
        />
        <PricingBox
          PricingList={dollarUS(Data && Data.Max_Daily_Loss)}
          percentage={(Data.Max_Daily_Loss / Data.account_balance) * 100 + "%"}
        />
        <PricingBox PricingList={Data && Data.Profit_Split + "%"} />
        <PricingBox
          PricingList={Data && Data.Bi_Weekly_Profit_Split ? "Yes" : "No"}
        />
        <PricingBox
          PricingList={
            "$" +
            (Data && Data.Max_Capital_Growth / 1000000).toFixed(0) +
            " Million"
          }
        />

        <button
          className="mtt-20"
          onClick={() => {
            handleNavi(Data.id);
          }}
        >
          {Data && isFreeTrial(Data.name) ? "Try Now" : "Buy Now"}
        </button>
      </div>
    </Grid>
  );
};

const ChallengesBoxM = ({ Data, index }) => {
  const navigate = useNavigate();
  const handleNavi = (id) => {
    navigate(`/FundingEvaluationPayment/${id}`);
  };
  return (
    <div className="challengesBoxM">
      <div className="Plan">{Data.name}</div>
      {Data.Leverage && (
        <div>
          <div className="Data">Leverage - {Data.Leverage}</div>
          <div className="LineSvg"></div>
        </div>
      )}
      {Data.Evaluation_Phase_1 && (
        <div>
          <div className="Data">
            Profit Target (Phase 1 -{Data.phase_1_total_days} Days){" "}
            {Data.Evaluation_Phase_1}
          </div>
          <div className="LineSvg"></div>
        </div>
      )}
      {Data.Evaluation_Phase_2 && (
        <div>
          <div className="Data">
            Profit Target (Phase 2 -{Data.phase_2_total_days} Days){" "}
            {Data.Evaluation_Phase_2}
          </div>
          <div className="LineSvg"></div>
        </div>
      )}
      {Data.Max_Loss && (
        <div>
          <div className="Data">Max Loss - {Data.Max_Loss}</div>
          <div className="LineSvg"></div>
        </div>
      )}
      {Data.Max_Daily_Loss && (
        <div>
          <div className="Data">Max Daily Loss - {Data.Max_Daily_Loss}</div>
          <div className="LineSvg"></div>
        </div>
      )}
      {Data.Profit_Split && (
        <div>
          <div className="Data">Profit Split- {Data.Profit_Split} </div>
          <div className="LineSvg"></div>
        </div>
      )}
      {Data.Bi_Weekly_Profit_Split && (
        <div>
          <div className="Data">
            Bi Weekly Profit Split- {Data.Bi_Weekly_Profit_Split ? "Yes" : "No"}
          </div>
          <div className="LineSvg"></div>
        </div>
      )}
      {Data.Profit_Split && (
        <div className="Data">Max Capital Growth -{Data.Profit_Split}</div>
      )}
      <button
        className="mtt-20"
        onClick={() => {
          handleNavi(Data.id);
        }}
      >
        {Data && isFreeTrial(Data.name) ? "Try Now" : "Buy Now"}
      </button>
    </div>
  );
};

const FundingEvaluation = () => {
  const [value, setValue] = React.useState("");
  const dispatch = useDispatch();

  const handleChange = (event) => {
    let Option = event.currentTarget.getAttribute("name");
    setValue(Option);
  };

  const [Data, setData] = useState(false);
  const ACCtoken = useSelector((state) => state.ACCtoken);
  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  useEffect(() => {
    dispatch(setLoading(true));
    axiosInstance
      .get("v3/challenges/", tokenConfig(myStore.getState))
      .then((res) => {
        dispatch(setLoading(false));
        if (res.data === "No Cases found!") {
          alert("No Cases found!");
          return;
        }
        if (res.data === "Please verify the Access Token!") {
          dispatch(logoutReducer());
          return;
        }

        setValue(Object.keys(res.data)[0]);
        setData(res.data);
      })
      .catch(function (error) {
        dispatch(setLoading(false));
        console.log(error);
        if (error.response) {
        }
      });
  }, [dispatch, ACCtoken]);

  const AccountBalance = [
    "Leverage",
    "Evaluation Phase 1 - Profit Target (35 Days)",
    "Evaluation Phase 2 - Profit Target (60 Days)",
    "Max Loss",
    "Max Daily Loss",
    "Profit Split",
    "Bi Weekly Profit Split",
    "Max Capital Growth",
  ];
  const [mainTabination, setMainTabination] = useState(2);
  const [activeTab, setActiveTab] = useState(mainTabination);

  useEffect(() => {
    setMainTabination(activeTab);
  }, [activeTab]);
  const tabItems = [
    {
      name: "Alpha Pro",
      value: 2,
    },
    {
      name: "Free Trial",
      value: 1,
    },
  ];

  return (
    <div
      className="FundingEvaluationContainer mbb-30 PageContainer"
      style={{ position: "relative" }}
    >
      <Loader open={open} />
      {/* <div className='FundSlider'>

        <Carousel
          showArrows={false}
          showStatus={false}
          className="CompetetionCarouselone"
        >
          <ChallengesBoxM />
          <ChallengesBoxM />
          <ChallengesBoxM />
        </Carousel>

      </div> */}

      <div className="newTabination">
        <div
          onClick={() => {
            setMainTabination(2);
          }}
          className={
            "newTabination-item " + (mainTabination === 2 && " active ")
          }
        >
          <div className="svg-con">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19H11.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5H12.75ZM14.4377 8.45175C14.6448 8.81047 15.1035 8.93338 15.4623 8.72627C15.821 8.51916 15.9439 8.06047 15.7368 7.70175L14.4377 8.45175ZM14.7117 7.42625L14.0622 7.80125V7.80125L14.7117 7.42625ZM11.1301 11.68L11.389 10.9761L11.389 10.9761L11.1301 11.68ZM12.8702 12.32L13.1291 11.6161L13.129 11.6161L12.8702 12.32ZM9.28853 16.5738L8.63901 16.9488H8.63902L9.28853 16.5738ZM9.56249 15.5483C9.35538 15.1895 8.89669 15.0666 8.53797 15.2737C8.17925 15.4808 8.05634 15.9395 8.26345 16.2983L9.56249 15.5483ZM13.3279 17.6561L12.9529 17.0066L13.3279 17.6561ZM10.6723 6.34391L11.0473 6.99343L10.6723 6.34391ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25C1.25 17.9371 6.06294 22.75 12 22.75V21.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM12 2.75C17.1086 2.75 21.25 6.89137 21.25 12H22.75C22.75 6.06294 17.9371 1.25 12 1.25V2.75ZM15.7368 7.70175L15.3612 7.05125L14.0622 7.80125L14.4377 8.45175L15.7368 7.70175ZM9.93805 16.1988L9.56249 15.5483L8.26345 16.2983L8.63901 16.9488L9.93805 16.1988ZM12.6113 13.0239C14.3674 13.6699 14.5734 16.071 12.9529 17.0066L13.7029 18.3056C16.4247 16.7341 16.0788 12.7011 13.1291 11.6161L12.6113 13.0239ZM10.2973 5.6944C7.57547 7.26586 7.92143 11.2989 10.8712 12.3839L11.389 10.9761C9.63281 10.3301 9.42685 7.92902 11.0473 6.99343L10.2973 5.6944ZM12.75 19V18.049H11.25V19H12.75ZM12.75 18.049V12H11.25V18.049H12.75ZM12.9529 17.0066C12.6383 17.1882 12.2996 17.2831 11.9624 17.3L12.0376 18.7981C12.6068 18.7695 13.1776 18.6089 13.7029 18.3056L12.9529 17.0066ZM11.9624 17.3C11.1595 17.3403 10.366 16.94 9.93805 16.1988L8.63902 16.9488C9.35925 18.1962 10.6945 18.8655 12.0376 18.7981L11.9624 17.3ZM10.8711 12.3839L11.7411 12.7039L12.2589 11.2961L11.389 10.9761L10.8711 12.3839ZM11.7411 12.7039L12.6113 13.0239L13.129 11.6161L12.2589 11.2961L11.7411 12.7039ZM12.75 12L12.75 5.95097H11.25L11.25 12H12.75ZM12.75 5.95097V5H11.25V5.95097H12.75ZM15.3612 7.05125C14.6409 5.80369 13.3055 5.13442 11.9624 5.20192L12.0376 6.70003C12.8406 6.65968 13.6342 7.05999 14.0622 7.80125L15.3612 7.05125ZM11.9624 5.20192C11.3933 5.23052 10.8226 5.39115 10.2973 5.6944L11.0473 6.99343C11.3619 6.81182 11.7005 6.71697 12.0376 6.70003L11.9624 5.20192Z"
                fill="white"
              />
            </svg>
          </div>
          Alpha Pro
        </div>
        <div
          onClick={() => {
            setMainTabination(1);
          }}
          className={
            "newTabination-item " + (mainTabination === 1 && " active ")
          }
        >
          <div className="svg-con">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="free-trial-icon"
            >
              <path
                d="M10.8718 2.87493C12.7548 2.28121 13.6963 1.98435 14.5166 2.00064C16.2319 2.0347 17.8099 2.94576 18.697 4.41418C19.1213 5.11646 19.3349 6.08025 19.7623 8.00783C19.9282 8.75645 20.0112 9.13076 20.0371 9.50123C20.0908 10.2681 19.9669 11.0371 19.6751 11.7483C19.5341 12.0919 19.3378 12.4212 18.9451 13.0798L16.4869 17.2027C15.5956 18.6976 15.1499 19.4451 14.6006 19.9449C13.3849 21.0511 11.7031 21.4891 10.1023 21.1165C9.37889 20.9481 8.62522 20.513 7.11788 19.6427C5.61054 18.7725 4.85687 18.3373 4.34938 17.7951C3.22628 16.595 2.76472 14.9196 3.1148 13.3136C3.27299 12.588 3.6975 11.8283 4.54651 10.3088L6.88793 6.11862C7.26197 5.44924 7.44899 5.11455 7.67605 4.82067C8.14608 4.21233 8.75007 3.72056 9.44106 3.3836C9.77486 3.22082 10.1405 3.10552 10.8718 2.87493Z"
                stroke="gray"
                stroke-width="1.5"
              />
              <path
                d="M11.9065 7.58122C11.4232 8.41823 11.71 9.48852 12.547 9.97177C13.3841 10.455 14.4543 10.1682 14.9376 9.33122C15.4208 8.49421 15.1341 7.42393 14.297 6.94068C13.46 6.45743 12.3897 6.74421 11.9065 7.58122Z"
                stroke="white"
                stroke-width="1.5"
              />
            </svg>
          </div>
          Free Trial
        </div>
      </div>

      <div className="mobileTabOption">
        <MobileTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabItems={tabItems}
        />
      </div>

      {mainTabination === 2 && (
        <div className="ChallengeDesk">
          <Challenges data={Data["Alpha Pro"]} type="dynamic" />
        </div>
      )}

      {mainTabination === 1 && (
        <div className="ChallengeDesk">
          <Challenges data={Data["Free Trial"]} type="dynamic" />
        </div>
      )}
    </div>
  );
};

export default FundingEvaluation;
